import Nav from './components/Nav';
import Hero from './components/Hero';
import Steps from './components/Steps';

function App() {
  
  return (


    <main className="wrapper">
         <Nav/>
         <Hero/>
         <Steps/>
         </main>

  );
}

export default App;
